export const changeshowSentinel2NDVIDotReducer = (state = false, action) => {
  switch (action.type) {
    case "CHANGE_showSentinel2NDVIDot":
      return action.payload.showSentinel2NDVIDot;
    default:
      return state;
  }
};
